__turbopack_context__.v({
  "cell": "P9VnLW_cell",
  "orderIcons": "P9VnLW_orderIcons",
  "reTryPaymentButton": "P9VnLW_reTryPaymentButton",
  "row": "P9VnLW_row",
});
